<template>
  <div class="media-swiper" :class="{'has-pagination': list.length > 1}">
    <Swiper v-bind="swiperOptions">
      <SwiperSlide v-for="(item, index) in list" :key="index">
        <div class="media" v-if="item">
          <img loading="lazy" v-if="getMediaType(item) === 'image'" :src="item" :alt="alt || 'media'" @load="onImageLoad" />
          <video
            v-else-if="getMediaType(item) === 'video'"
            :src="item"
            :aria-label="alt || 'media'"
            autoplay
            muted
            loop
            playsinline
            webkit-playsinline
            x5-playsinline
          ></video>
        </div>
      </SwiperSlide>
    </Swiper>
    <div v-show="list.length > 1" class="custom-pagination" ref="paginationEl"></div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, nextTick, watch } from 'vue'

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import { getMediaType } from '@/utils/utils'
const props = defineProps({
  mediaList: {
    type: String,
    default: ''
  },
  /** SEO：轮播图 alt，缺省回退 media */
  alt: {
    type: String,
    default: ''
  }
})
const list = ref<string[]>([])

const paginationEl = ref<HTMLElement | null>(null)
const swiperOptions = ref<any>({
  modules: [Autoplay, Pagination],
  autoplay: { delay: 3000, pauseOnMouseEnter: true },
  pagination: {
    el: null, // 初始化设 null，后面再赋值
    clickable: true
  },
  loop: true,
  spaceBetween: 20,
  nested: true,
  touchMoveStopPropagation: true,
  touchReleaseOnEdges: true
})
watch(
  () => props.mediaList,
  () => {
    if (props.mediaList) {
      list.value.push(...props.mediaList.split(','))
    }
  },
  { deep: true, immediate: true }
)
const onImageLoad = () => {
  nextTick(() => {
    // 确保图片加载完成后，进行 Swiper 分页的初始化
    if (paginationEl.value) {
      swiperOptions.value.pagination.el = paginationEl.value
    }
  })
}
onMounted(async () => {
  if (props.mediaList) {
    list.value = props.mediaList.split(',')
  }
})
</script>

<style lang="scss" scoped>
.media-swiper {
  width: 100%;
  position: relative;
  .custom-pagination {
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translate(-50%, 100%);
    flex-wrap: nowrap;
    display: flex;
    justify-content: center;
  }
  .swiper-slide {
    height: auto;
  }
  .media {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    img,
    video {
      // width: 100%;
      height: 100%;
      max-width: 440px;
      max-height: 533px;
      object-fit: contain; // 保持比例，不变形
      background: url('@/assets/images/iconSvg/logo_no_pic.svg') center center no-repeat;
      background-size: 60% auto;
    }
  }
}
@media (max-width: 1200px) {
  .media-swiper .media{
    img,
    video {
      max-width: 100%;
    }
  }
}
@media (max-width: 767px) {
  .media-swiper .custom-pagination {
    bottom: -10px;
  }
}
@media (max-width: 460px) {
  .media-swiper .custom-pagination {
    bottom: -5px;
  }
}
</style>
